<template>
  <v-dialog
    class="grey"
    v-model="show"
    :retain-focus="false"
    transition="slide-y-transition"
    max-width="450"
    @click:outside="hideModal"
  >
    <v-card
      :class="['pa-2 pt-0 pb-0']"
    >
      <v-row
        no-gutters
        align="center"
      >
        <v-col class="headline" />
        <v-col cols="auto">
          <v-btn
            small
            fab
            icon
            @click="hideModal"
          >
            <v-icon>
              close
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-container
        class="dialog-content text-center"
      >
        <div class="logo">
          <v-img
            class="mx-auto"
            :src="logoUrl"
            :width="180"
            contain
          />
        </div>

        <h3 class="px-1 apply-title">
          In order to apply to the opportunity you selected, please create a profile with us first
        </h3>

        <LoginBtnWithRules
          class="login-btn-wrap"
          @login="handleLoginClick"
        />
      </v-container>
      <div class="dialog-bg-image" />
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { State } from 'vuex-class'
import { mapGetters } from 'vuex'

import { isIos, isInstallPWAEventExists, canAddAppToHomeScreen, waitAsync } from '@/utils/common'
import LoginBtnWithRules from '@/components/core/LoginBtnWithRules.vue'
import AuthService from '@/services/auth.service'

@Component({
  components: {
    LoginBtnWithRules
  },
  computed: {
    ...mapGetters(['authenticated'])
  }
})
export default class LoginDialog extends Vue {
  @Prop({ default: false, required: true }) show: boolean
  @Prop({ required: false }) authState: { [key:string]: any }

  // data
  logoUrl: string = require('@/assets/images/logo.svg')

  // computed
  authenticated: boolean

  get showDialog (): boolean {
    return this.show
  }

  set showDialog (value: boolean) {
    this.$emit('update:show', value)
  }

  // lifecycle hooks

  // methods
  hideModal () {
    this.showDialog = false
    this.$emit('hide')
  }

  handleLoginClick () {
    const appState = JSON.stringify(this.authState || {
      redirectTo: this.$route.fullPath
    })
    AuthService.login(appState)
  }

}
</script>
<style lang="scss" scoped>
.dialog-content {
  position: relative;
  z-index: 1;
  max-width: 306px;
  .media-lg-desktop & {
    max-width: 490px;
  }
}
.login-close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
}
.login-btn-wrap {
  position: relative;
  margin: 0 auto;
  width: 100%;
  .media-lg-desktop & {
    height: auto;
  }
}
.dialog-bg-image {
  position: absolute;
  bottom: 0;
  left: 0;
  max-height: 250px;
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-image: url('~@/assets/images/login/login-waves-bg-desktop.svg');
  background-size: cover;
  background-position: top center;
  .media-xs & {
    background-image: url('~@/assets/images/login/login-waves-bg-mobile.svg');
    max-height: 240px;
  }
  .media-lg-desktop & {
    max-height: 430px;
  }
}
.apply-title {
  font-size: 16px;
  line-height: 1.25;
  padding: 15px 5px 20px 5px;
  .media-lg-desktop & {
    font-size: 26px;
    padding-bottom: 25px;
  }
}
</style>
